import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'convertStringBooleanToBoolean',
})
export class ConvertStringBooleanToBooleanPipe implements PipeTransform {
	transform(value: unknown): unknown {
		if (typeof value === 'boolean') {
			return value;
		}
		if (typeof value === 'string' && (value === 'true' || value === 'false')) {
			return value === 'true';
		}
		return value;
	}
}
